module.exports = __webpack_public_path__ + "img/confirm.1654b46a.png";